import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import MovieHelpers from '../utils/MovieHelpers';
import placeholderImage from '../../../images/movies/ph-movie-poster.jpg';


export default class MovieItem extends React.Component {

    static propTypes = {
        movie: PropTypes.object.isRequired
    };

    renderImage(movie) {
        if(!movie.posterUrl) {
            return <img src={placeholderImage} className="movies-page__movies__list__item__poster"/>
        } else {
            return <img src={movie.posterUrl} className="movies-page__movies__list__item__poster"/>
        }
    }

    render() {
        const { movie } = this.props;
        const ratingClassName = classNames('movies-page__movies__list__item__rating', {
            'movies-page__movies__list__item__rating--always': movie.rating !== 'EA'
        });
        const extraInfoClassName = classNames('movies-page__movies__list__item__extra-info', {
            'movies-page__movies__list__item__extra-info--always': movie.otherVersions.length > 0
        });

        return (
            <li className="movies-page__movies__list__item">
                <Link to={`/view/${movie._id}`} onClick={window.logAction}>
                    <div className="movies-page__movies__list__item__poster__holder">
                        {this.renderImage(movie)}
                        <div className="movies-page__movies__list__item__poster__overlay">
                            {movie.format === '3d' ? <span className="movies-page__movies__list__item__format-3d">3D</span> : null }
                            <span className={ratingClassName}>
                                {movie.rating}
                            </span>
                        </div>
                    </div>
                    <span className="movies-page__movies__list__item__title">
                        {movie.title}
                    </span>
                    <span className={extraInfoClassName}>
                        <span className="movies-page__movies__list__item__duration">
                            {MovieHelpers.safeMovieDuration( movie.duration )}
                        </span>
                        <span className="movies-page__movies__list__item__version">
                            {movie.version}
                        </span>
                    </span>
                </Link>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./js/movies/components/MovieItem.jsx